<template>
  <div>
    <!-- <div style="text-align: center;color: #ccc;" :style="{fontSize: $px2rem(15)}">{{echartsTime}}</div> -->
    <div style="text-align: center;" :style="{fontSize: $px2rem(25)}"><span :style="{fontSize: $px2rem(13)}"> </span> <b></b><span :style="{fontSize: $px2rem(20)}"> {{name}}次/分</span></div>
    <div class="health-chart-content">
      <div ref="chart" class="health-chart"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      data:[],
      nameData:[],
      echartsTime:'00:00',
      name:'0',
      chartInstance: null,
    }
  },
  props: [
    "details",
    "detailTimes"
  ],
  watch: {
    details: function (newVal, oldVal) {
      this.data = newVal
      this.name = newVal[newVal.length-1]
      console.log(newVal)
    },
    detailTimes: function (newVal,oldVal) {
      this.nameData = newVal
  
      console.log(newVal,32)
      this.initChart();
    }
  },
  mounted() {
  
  },
  beforeDestroy() {
    // 在组件销毁前移除resize事件监听
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.chartInstance.resize();
    },
    renderCardList(data) {
      this.echartsTime = data.name;
      this.name = data.value;
    },
    initChart() {
      const chartDom = this.$refs.chart;

      this.chartInstance = echarts.init(chartDom);

      const option = {
        grid: {
          top: 20,
          right: 30,
          bottom: 20,
          left: 15
        },
        tooltip: {
        
          trigger: "axis",
          extraCssText: 'z-index: -1',
          axisPointer: {
            
            type: "line",
           
            lineStyle: {
              color: "red", // 修改线型指示器的颜色为红色
              width: 1, // 指示器线宽
              
            },
            
          },
          formatter: (params) => {
            console.log(params)
            let obj = params[0];
        // this.renderCardList处理对应数据
        this.renderCardList(obj)
     
    },

          clickable: true,
         
        },
        xAxis: {
          type: "category",
          data: this.nameData,
          clickable: true
        },
        yAxis: {
          type: "value",
          position: "right",
          alignTicks: true,
          axisLine: {
            show: true,
          },
          min: 40,  // 设置纵坐标起始值为40
          max: 160, // 设置纵坐标结束值为160
          splitNumber: 4, // 设置纵坐标分割线数量为4
          interval: 30 // 设置纵坐标间隔为30
        },
        series: [
          {
            data: this.data,
            type: "line",
            smooth: true,
            lineStyle: {
              normal: {
                color: "red",
                width: 1 // 设置线的粗细
              },
            },
            itemStyle: {
              color: "red",
            },
            
            areaStyle: {
              //折线图颜色半透明
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(255, 0, 0, 0.4)", // 上部颜色
                },
                {
                  offset: 1,
                  color: "rgba(255, 0, 0, 0)", // 下部颜色
                },
              ]),
            },
            markLine: {
              // 上下图标可以单独设置，可为空
              symbol: [],
              symbolSize: [14, 17],
              label: {
                show: true,
                padding: [0, 0, 5, 0],
                formatter() {
                  return "指示线";
                },
              },
            },
          },
        ],
      };

      this.chartInstance.setOption(option);
      window.addEventListener("resize", this.handleResize);
    },
  },
};
</script>

<style lang="less" scoped>
/* 图表容器样式 */
.health-chart-content {
  border: 1px solid #F0F0F0;
  border-radius: 10px;
  padding: 16px;
  background: #FFFFFF;
  margin: 15px 0 16px 0;
}

.health-chart {
  width: 100%;
  height: 192px;
}
</style>


// WEBPACK FOOTER //
// src/views/echarts.vue